import React from 'react'

export default function TableBadge({ tableNumber, subtitle }) {
  return (
    <div className="bg-white rounded-2xl p-6 w-full text-center">
      <p className="text-sm text-gray-500 mb-1">{subtitle || 'Your table'}</p>
      <p className="text-4xl font-bold text-sky-900">Table {tableNumber}</p>
    </div>
  )
}
